import { Injectable } from '@angular/core';
import { PlessHttp } from 'src/app/shared/http/pless-http.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessDialogServiceSub } from 'src/app/commons/kymw00/pless-dialog-service-sub';
import { KYMW7400Model } from '../kymw7400.model';

import type {
  DeleteRememberGoodsListCombination,
  DeleteRememberGoodsListParameter,
} from '../vo/delete-remember-goods-list-combination.model';

// リクエスト構造
export interface DeleteRememberGoodsListRequest {
  delete: {
    DeleteRememberGoodsList: {
      combination: DeleteRememberGoodsListCombination[];
    };
  };
}

/**
 * 忘れず注文商品削除サービス
 * @export DeleteRememberGoodsListService
 * @class DeleteRememberGoodsListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class DeleteRememberGoodsListService extends PlessJsonResponderSub<any> {
  model: KYMW7400Model;
  private requestData: DeleteRememberGoodsListRequest;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof DeleteRememberGoodsListService
   */
  private getBody(request: DeleteRememberGoodsListParameter[]): PlessRequest {
    // 削除対象を設定
    const combinations = [] as DeleteRememberGoodsListCombination[];

    for (const item of request) {
      const parameter: DeleteRememberGoodsListParameter = {
        RememberGoodsId: item.RememberGoodsId,
        OrderReceptionStartCatalog: item.OrderReceptionStartCatalog,
        OrderReceptionEndCatalog: item.OrderReceptionEndCatalog,
        OrderNum: item.OrderNum,
        OrderChangeOrderNum: item.OrderChangeOrderNum,
      };
      combinations.push({ parameter });
    }

    // リクエストを設定
    this.requestData = {
      delete: {
        DeleteRememberGoodsList: { combination: combinations },
      }
    };

    return new PlessRequest(this.requestData);
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof DeleteRememberGoodsListService
   */
  execute(model: KYMW7400Model, request: DeleteRememberGoodsListParameter[], successFunc: Function = null): void {
    this.model = model;
    this.successFunc = successFunc;
    this.send('deleteRememberGoodsList', this.getBody(request));
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof DeleteRememberGoodsListService
   */
  success(data: any) {
    if (this.successFunc) {
      this.successFunc();
    }
  }

}
